import { render, staticRenderFns } from "./freeCRM.vue?vue&type=template&id=d8c2c07c&scoped=true"
import script from "./freeCRM.vue?vue&type=script&lang=js"
export * from "./freeCRM.vue?vue&type=script&lang=js"
import style0 from "./freeCRM.vue?vue&type=style&index=0&id=d8c2c07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c2c07c",
  null
  
)

export default component.exports